import { useApplyTheme } from "@/hooks/use-theme";
import { useApplyLayoutMode } from "@/hooks/use-layout-mode";

/**
 * Mirrors the stored device preferences onto `<html>`: the theme as `data-theme`,
 * the layout (split | index) as `data-layout`. Renders nothing.
 *
 * Mounted at the root in `main.tsx` rather than in a layout because the theme has to
 * be right on every route, and the auth pages and the landing page share no layout
 * with `/y`. Its own file so `main.tsx` keeps exporting only what it exported before.
 */
export function ThemeSync() {
  useApplyTheme();
  useApplyLayoutMode();
  return null;
}
